import React from "react";
import { useLocalStorage } from "utilities/usehooks";

export const useCollapsedState = (uniqueId: string, startCollapsed = false, isPersistent = true) => {
  const [collapsed, setCollapsed] = isPersistent
    ? useLocalStorage<boolean>(`collapsedSection:${uniqueId}`, startCollapsed)
    : React.useState(startCollapsed);

  const toggleCollapsed = () => {
    setCollapsed(prev => {
      const newValue = !prev;
      return newValue;
    });
  };

  return { collapsed, toggleCollapsed, setCollapsed };
};